<section id="slider">
  <div class="gradient">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <div class="slider-title">
            Aracının Güncel 2.El Piyasa Değerini
          </div>
          <div class="learn">
            <a href="https://www.cardataplus.com" target="_blank" class="btn btn-m btn-primary">
              Hemen Öğren
            </a>
          </div>
        </div>
        <div class="col-md-6">
          <div class="slider-title">
            Aracını Değerinde
          </div>
          <div class="learn">
            <a href="https://hemensat.cardata.com.tr" target="_blank" class="btn btn-m btn-primary">
              Hemen Satın Alıyoruz
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<div class="seperator"></div>
<section class="section-ev">
  <img src="assets/img/hybrid-ev.webp" class="section-ev-bg" alt="" />
  <div class="section-ev-content">
    <h3><span class="blue">Elektrikli</span> ve <span class="green">Hibrit</span><br />Aracının Değeri Ne&nbsp;Kadar?</h3>
    <a href="https://www.cardataplus.com" target="_blank">Aracını Değerle <i class="fa fa-arrow-right"></i></a>
  </div>
</section>
<!-- <section class="section-truck d-none d-sm-none d-md-block">
  <img src="assets/img/orange_car.jpg" class="img-responsive" />
  <div class="block">
    <img src="assets/img/logo-open-ai.png" />
    <h3>CARDATA ChatGPT</h3>
    <a href="https://dialogbase.co/products/cardata-ile-ikinci-el-arac-fiyati-sorgulama-botu" target="_blank">Hemen
      Tıkla</a>
  </div>
</section>
<section class="section-truck section-truck2 d-block d-xl-none d-lg-none d-md-none">
  <img src="assets/img/orange_car.jpg" class="img-responsive" />
  <div class="block">
    <h3>CARDATA ChatGPT</h3>
    <a href="https://dialogbase.co/products/cardata-ile-ikinci-el-arac-fiyati-sorgulama-botu" target="_blank">Hemen
      Tıkla</a>
  </div>
</section> -->
<div class="seperator"></div>
